/* eslint-disable */
import React, { useRef } from "react"

import { Box, Fade, Typography, IconButton, Stack } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import ZoomOutOutlinedIcon from "@mui/icons-material/ZoomOutOutlined"

import useAudioContext from "../../utils/eSteth/AudioState"
import Player from "../Player"
import AudioChart from "../AudioChart"
import VolumeBar from "./VolumeBar"

const AudioPlot = () => {
	const { audio, closeAudioPlot } = useAudioContext()

	const audioRef = useRef()
	const chartRef = useRef(null)

	const chartWidth = 94

	const closeAudioPlotHandler = () => {
		closeAudioPlot()
	}

	const resetZoomHandler = () => {
		chartRef.current.resetZoom()
	}

	if (!audio) return <></>

	return (
		<Fade in={Boolean(audio)}>
			<Box sx={{ width: "full", padding: "1rem", border: "1px solid black", borderRadius: "0.5rem" }}>
				<audio ref={audioRef} preload="metadata">
					<source src={`http://localhost:5003/recording/${audio.id}`} type="audio/wav" />
				</audio>
				<Stack
					sx={{
						width: "full",
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
					}}
					spacing={2}
					direction="row"
				>
					<IconButton color="default" onClick={resetZoomHandler}>
						<ZoomOutOutlinedIcon />
					</IconButton>
					<Typography variant="h6">{`Audio Recording from ${audio.id}`}</Typography>
					<IconButton color="default" onClick={closeAudioPlotHandler}>
						<CloseIcon />
					</IconButton>
				</Stack>
				<Box
					sx={{
						width: "full",
						display: "flex",
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
					}}
				>
					<Stack
						spacing={4}
						sx={{
							width: `${100 - chartWidth}%`,
							flexDirection: "column",
							alignItems: "center",
							justifyContent: "end",
							paddingBottom: "10px",
						}}
					>
						<VolumeBar audioRef={audioRef} />
					</Stack>
					<Box sx={{ width: `${chartWidth}%` }}>
						<AudioChart chartRef={chartRef} />
					</Box>
				</Box>
				<Player audioRef={audioRef} />
			</Box>
		</Fade>
	)
}

export default AudioPlot

